import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

import { Observable ,  of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { NeptuneApi } from '../genericApi/neptune.api';
import { BriefingConfigApi } from './model/briefing-config.api.model';

// Tied to backend
export enum ProminenceRecalculationJobStatus {
    PENDING = 'PENDING',
    ONGOING = 'ONGOING',
    DONE = 'DONE',
    FAILED = 'FAILED'
}

@Injectable()
export class BriefingConfigApiService {
    constructor(
        private neptuneApi: NeptuneApi,
    ) { }

    /**
     * Gets all briefing configs whos accounts are associated with the current user
     */
    getConfig(): Observable<BriefingConfigApi> {
        const slug = '/configurations/briefings';

        return this.neptuneApi.api<BriefingConfigApi>(
            slug,
            null,
            HttpVerbsEnum.GET,
        ).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && (<HttpErrorResponse> error).status === 404) {
                    return of(null);
                }
                throw error;
            })
        );
    }

    // Admin
    getById(accountId: number): Observable<BriefingConfigApi> {
        const slug = `/configurations/briefings/accounts/${accountId}`;

        return this.neptuneApi.api<BriefingConfigApi>(
            slug,
            null,
            HttpVerbsEnum.GET,
        ).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && (<HttpErrorResponse> error).status === 404) {
                    return of(null);
                }
                throw error;
            })
        );
    }

    // Admin
    create(accountId: number, config: BriefingConfigApi): Observable<void> {
        const slug = `/configurations/briefings/accounts/${accountId}`;

        return this.neptuneApi.api<void>(
            slug,
            config,
            HttpVerbsEnum.POST,
        );
    }

    // Admin
    update(accountId: number, config: BriefingConfigApi, locale: string): Observable<void> {
        const slug = `/configurations/briefings/accounts/${accountId}`;

        return this.neptuneApi.api<any>(
            slug,
            config,
            HttpVerbsEnum.PUT,
        ).pipe(
            catchError(error => {
                if (error instanceof HttpErrorResponse && (<HttpErrorResponse> error).status === 404) {
                    return of(null);
                }
                throw error;
            })
        );
    }

    // Admin
    delete(accountId: number): Observable<void> {
        const slug = `/configurations/briefings/accounts/${accountId}`;

        return this.neptuneApi.api<any>(
            slug,
            null,
            HttpVerbsEnum.DELETE,
        );
    }
}
